import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [isScrolled, setIsScrolled] = useState(false);
  //const [counters, setCounters] = useState({ clients: 0, assets: 0, years: 0, satisfaction: 0 });
  const [hasAnimated, setHasAnimated] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [language, setLanguage] = useState('english');

  const heroRef = useRef(null);
  const servicesRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  //const statsRef = useRef(null);

  const content = {
    english: {
      nav: [
        { id: 'home', label: 'Home' },
        { id: 'services', label: 'Services' },
        { id: 'about', label: 'About' },
        { id: 'contact', label: 'Contact' }
      ],
      hero: {
        title1: 'Your Financial',
        title2: 'Success Partner',
        description: 'Grow your business confidently with fast, flexible, and collateral-free loans.',
        button1: 'Explore Services',
        button2: 'Get Consultation'
      },
      expertise: {
        title: 'Our Expertise',
        description: 'Discover how our comprehensive financial services can transform your financial journey'
      },
      services: {
        title: 'Our Services',
        description: 'Comprehensive financial solutions tailored to meet your unique needs and help you achieve your financial goals with confidence.',
        items: [
          {
            title: 'Hassle-Free Business Loans',
            description: 'Empower your business with fast, flexible funding options ranging from ₹5 lakhs to ₹5 crores — no collateral required.',
            features: ['No collateral or down payment required','No CIBIL score needed','Zero processing fees','Loan disbursal in just 2 working days']
          },
          {
            title: 'Simple and Transparent Eligibility',
            description: 'We simplify the approval process so you can focus on growth — not paperwork.',
            features: ['Business must be operational for at least 2 years','Monthly bank turnover should exceed ₹10 lakhs','Cheque-based loan disbursement only','No hidden requirements or red tape']
          },
          {
            title: 'Expert Legal and Repayment Guidance',
            description: 'Get dedicated support for documentation, legal clarity, and repayment planning.',
            features: ['Support for self-employed, company owners, factory owners, wholesalers, and retailers','Legal advisory for documentation and compliance','Flexible repayment in 20 weeks (5 months)','Installment options: weekly or once every 15 days']
          }
        ]
      },
      // stats: {
      //   title: 'Trusted by Thousands',
      //   description: 'Join thousands of satisfied clients who have achieved their financial goals with us.',
      //   items: [
      //     { label: 'Happy Clients', prefix: '', suffix: '+' },
      //     { label: 'Assets Managed', prefix: '$', suffix: 'M+' },
      //     { label: 'Years Experience', prefix: '', suffix: '+' },
      //     { label: 'Satisfaction Rate', prefix: '', suffix: '%' }
      //   ]
      // },
      about: {
        title1: 'Why Choose',
        title2: 'Shivani Financial Services',
        description: 'At Shivani Financial Services, we’re more than just a lender — we’re your financial growth partner. We’re committed to helping you succeed with integrity, speed, and personal care.',
        items: [
          { title: 'Secure & Trusted', description: 'Bank-level security and compliance' },
          { title: 'Transparent', description: 'Clear, honest, and hassle-free process from start to finish.' },
          { title: 'Empowering', description: 'Focused on supporting small and growing businesses with fast funding.' }
        ]
      },
      // contact: {
      //   title: 'Get In Touch',
      //   description: 'Ready to take control of your financial future? Contact us today for a free consultation.',
      //   formTitle: 'Send us a message',
      //   form: {
      //     firstName: 'First Name',
      //     lastName: 'Last Name',
      //     email: 'Email',
      //     phone: 'Phone',
      //     serviceInterest: 'Service Interest',
      //     message: 'Message',
      //     submit: 'Send Message'
      //   },
      //   infoTitle: 'Contact Information',
      //   info: [
      //     { title: 'Phone', info: '+1 (555) 123-4567' },
      //     { title: 'Email', info: 'info@financemax.com' },
      //     { title: 'Office', info: '123 Financial District, New York, NY 10004' }
      //   ]
      // },
      footer: {
        description: 'Your trusted partner in financial success.',
        services: ['Hassle-Free Business Loans','Simple and Transparent Eligibility','Expert Legal and Repayment Guidance'],
        contact: ['+91 9566666825', 'shivanifinancialservices@gmail.com'],
        copyright: '© 2025 ShivaniFinancialServices. All rights reserved.'
      }
    },
    tamil: {
      nav: [
        { id: 'home', label: 'முகப்பு' },
        { id: 'services', label: 'சேவைகள்' },
        { id: 'about', label: 'பற்றி' },
        { id: 'contact', label: 'தொடர்பு' }
      ],
      hero: {
        title1: 'உங்கள் நிதி',
        title2: 'வெற்றி பங்குதாரர்',
        hero: 'வேகமானது, நெகிழ்வானது மற்றும் உத்தரவாதமில்லாத கடன்களுடன் உங்கள் வணிக வளர்ச்சியை நம்பிக்கையுடன் தொடங்குங்கள்.',
        button1: 'சேவைகளை ஆராயுங்கள்',
        button2: 'ஆலோசனை பெறுங்கள்'
      },
      expertise: {
        title: 'எங்கள் நிபுணத்துவம்',
        description: 'எங்கள் விரிவான நிதி சேவைகள் உங்கள் நிதி பயணத்தை எவ்வாறு மாற்ற முடியும் என்பதை கண்டறியவும்'
      },
      services: {
        title: 'எங்கள் சேவைகள்',
        description: 'உங்கள் தேவைகளை பூர்த்தி செய்ய வடிவமைக்கப்பட்ட விரிவான நிதி தீர்வுகள்.',
        items: [
  {
    title: 'சிரமமில்லா வணிக கடன்கள்',
    description: '₹5 லட்சம் முதல் ₹5 கோடி வரை வேகமான மற்றும் நெகிழ்வான நிதியுதவிகளுடன் உங்கள் வணிகத்தை வலுப்படுத்துங்கள் — எந்த உத்தரவாதமும் தேவையில்லை.',
    features: [
      'எந்த உத்தரவாதம் அல்லது முன்பணம் தேவையில்லை',
      'CIBIL மதிப்பெண் தேவையில்லை',
      'நடைமுறை கட்டணம் கிடையாது',
      'இரண்டு நாட்களில் கடன் தொகை பெற்று கொள்ளலாம்'
    ]
  },
  {
    title: 'எளிதான மற்றும் தெளிவான தகுதிகள்',
    description: 'நாங்கள் அங்கீகார செயல்முறையை எளிமையாக்கி, நீங்கள் வளர்ச்சியில் கவனம் செலுத்தலாம் — ஆவணங்களின் சிக்கலில் அல்ல.',
    features: [
      'நிறுவனம் 2 ஆண்டுகள் செயல்பாடிருக்க வேண்டும்',
      'மாதம் 10 லட்சத்திற்கு மேல் வங்கி கணக்கில் பரிவர்த்தனை இருக்க வேண்டும்',
      'காசோலை அடிப்படையில் மட்டும் கடன் கிடைக்கும்',
      'மறைமுக தேவைகள் அல்லது சிக்கல்கள் இல்லை'
    ]
  },
  {
    title: 'நிபுணர் சட்ட மற்றும் திருப்பி செலுத்தும் வழிகாட்டி',
    description: 'ஆவணங்கள், சட்ட தெளிவுகள் மற்றும் திருப்பி செலுத்தும் திட்டமிடலுக்கு அர்ப்பணிக்கப்பட்ட ஆதரவு பெறுங்கள்.',
    features: [
      'சுயதொழில் செய்வோர், நிறுவன உரிமையாளர்கள்,தொழிற்சாலை உரிமையாளர்கள். மொத்தம் மற்றும் சில்லறை வணிகர்களுக்கான ஆதரவு',
      'ஆவணங்கள் மற்றும் இணக்கம் குறித்த சட்ட ஆலோசனை',
      '20 வாரங்களில்  திரும்ப செலுத்த வேண்டும். (5 மாதம்)',
      'தவணை கட்டணம் செலுத்தும் விருப்பங்கள்: வாராந்திரம் அல்லது 15 நாளுக்கு ஒருமுறை'
    ]
  }
]

      },
      // stats: {
      //   title: 'ஆயிரக்கணக்கானவர்களால் நம்பப்படுகிறது',
      //   description: 'எங்களுடன் தங்கள் நிதி இலக்குகளை அடைந்த ஆயிரக்கணக்கான திருப்தியடைந்த வாடிக்கையாளர்களுடன் இணையுங்கள்.',
      //   items: [
      //     { label: 'மகிழ்ச்சியான வாடிக்கையாளர்கள்', prefix: '', suffix: '+' },
      //     { label: 'நிர்வகிக்கப்பட்ட சொத்துக்கள்', prefix: '$', suffix: 'M+' },
      //     { label: 'அனுபவ ஆண்டுகள்', prefix: '', suffix: '+' },
      //     { label: 'திருப்தி விகிதம்', prefix: '', suffix: '%' }
      //   ]
      // },
      about: {
        title1: 'ஏன் தேர்வு செய்ய வேண்டும்',
        title2: 'ஷிவானி நிதி சேவைகள்',
        description: 'ஷிவானி நிதி சேவைகளில், நாங்கள் வெறும் கடன் வழங்குநர்கள் அல்ல — உங்கள் நிதி வளர்ச்சியின் துணைபுரிப்பாளர்கள். நேர்மை, வேகம் மற்றும் தனிப்பட்ட கவனத்துடன் உங்கள் வெற்றிக்கு அர்ப்பணிக்கப்பட்டுள்ளோம்.',
        items: [
  { title: 'பாதுகாப்பான மற்றும் நம்பகமான நிதி சேவை', description: 'வங்கி நிலை பாதுகாப்பு மற்றும் இணக்கம்' },
  { title: 'தெளிவான மற்றும் எளிமையான செயல்முறை', description: 'தொடக்கம் முதல் முடிவுவரை தெளிவான, நேர்மையான மற்றும் எளிதான செயல்முறை' },
  { title: 'வளர்ச்சிக்கான முழுமையான ஆதரவு', description: 'வேகமான நிதியுதவியுடன் சிறிய மற்றும் வளர்ந்து வரும் வணிகங்களை ஆதரிக்கும் நோக்கில்' }
]

      },
      // contact: {
      //   title: 'தொடர்பு கொள்ளுங்கள்',
      //   description: 'உங்கள் நிதி எதிர்காலத்தை கட்டுப்படுத்த தயாரா? இலவச ஆலோசனைக்கு இன்று தொடர்பு கொள்ளுங்கள்.',
      //   formTitle: 'எங்களுக்கு செய்தி அனுப்பவும்',
      //   form: {
      //     firstName: 'முதல் பெயர்',
      //     lastName: 'கடைசி பெயர்',
      //     email: 'மின்னஞ்சல்',
      //     phone: 'தொலைபேசி',
      //     serviceInterest: 'சேவை ஆர்வம்',
      //     message: 'செய்தி',
      //     submit: 'செய்தி அனுப்பவும்'
      //   },
      //   infoTitle: 'தொடர்பு தகவல்',
      //   info: [
      //     { title: 'தொலைபேசி', info: '+1 (555) 123-4567' },
      //     { title: 'மின்னஞ்சல்', info: 'info@financemax.com' },
      //     { title: 'அலுவலகம்', info: '123 நிதி மாவட்டம், நியூயார்க், NY 10004' }
      //   ]
      // },
      footer: {
  description: 'உங்கள் நம்பிக்கைக்குரிய நிதி வெற்றி பங்குதாரர்',
  services: ['எளிதான வணிக கடன்கள்', 'எளிமையான மற்றும் தெளிவான தகுதி', 'நிபுணரான சட்ட மற்றும் பணப்பரிவர்த்தனை வழிகாட்டல்'],
  contact: ['+91 9566666825', 'shivanifinancialservices@gmail.com'],
  copyright: '© 2025 ShivaniFinancialServices. அனைத்து உரிமைகளும் பாதுகாக்கப்படுகின்றன.'
}

    }
  };

  const slides = [
    {
      image: 'https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg',
      title: language === 'english' ? 'Tailored for Business Owners' : 'வணிக உரிமையாளர்களுக்கான தனிப்பயன் சேவை',
      description: language === 'english' ? 'Self-employed professionals, factory owners, company directors, wholesalers, and retailers — our loan solutions are designed just for you' : 'சுய தொழில்முனைவோர், தொழிற்சாலை உரிமையாளர்கள், நிறுவனர் இயக்குனர்கள், பெரிய மற்றும் சிறிய வணிகர்கள் — உங்கள் தேவைகளுக்கே ஏற்புடைய நாங்கள் வழங்கும் கடன் தீர்வுகள்.'
    },
    {
      image: 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg',
      title: language === 'english' ? 'Simple Eligibility, Big Opportunity' : 'எளிய தகுதி, பெரிய வாய்ப்பு',
      description: language === 'english' ? 'To qualify, your company should have operated for at least 2 years and maintain a monthly bank turnover of ₹10 lakhs or more. No CIBIL? No problem.' : 'தகுதி பெற, உங்கள் நிறுவனம் குறைந்தது 2 வருடங்களாக செயல்பட்டு, மாதாந்திர வங்கி வரவு ₹10 லட்சம் அல்லது அதற்கு மேற்பட்டதாக இருக்க வேண்டும். CIBIL மதிப்பெண் இல்லையா? பிரச்சனை இல்லை.'
    },
    {
      image: 'https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg',
      title: language === 'english' ? 'Complete Legal & Financial Guidance' : 'முழுமையான சட்ட மற்றும் நிதி வழிகாட்டி',
      description: language === 'english' ? 'From loan documentation to regulatory support, we help ensure your business stays compliant and ready for growth — without the complexity.' : 'கடன் ஆவணங்கள் தயாரித்தல் மற்றும் சட்ட ஆதரவு வழங்குதல் போன்றவையில், உங்கள் வணிகம் சட்டபூர்வமாக செயல்பட்டு வளர்ச்சிக்கு தயாராக இருக்க நாங்கள் உதவுகிறோம் — எளிமையாகவும் பிரச்சினைகள் இல்லாமல்.'
    }
  ];

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 15000);
    return () => clearInterval(slideInterval);
  }, [slides.length]);

  const scrollToSection = (sectionId) => {
    const refs = { home: heroRef, services: servicesRef, about: aboutRef, contact: contactRef };
    const targetRef = refs[sectionId];
    if (targetRef?.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const animateCounter = (target, setter, duration) => {
    let start = 0;
    const increment = target / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setter(target);
        clearInterval(timer);
      } else {
        setter(Math.floor(start));
      }
    }, 16);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsScrolled(scrollY > 50);
      const sections = [
        { id: 'home', ref: heroRef },
        { id: 'services', ref: servicesRef },
        { id: 'about', ref: aboutRef },
        { id: 'contact', ref: contactRef }
      ];
      for (const section of sections) {
        if (section.ref.current) {
          const rect = section.ref.current.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section.id);
            break;
          }
        }
      }
      // if (statsRef.current && !hasAnimated) {
      //   const rect = statsRef.current.getBoundingClientRect();
      //   if (rect.top <= window.innerHeight && rect.bottom >= 0) {
      //     setHasAnimated(true);
      //     animateCounter(2500, (val) => setCounters(prev => ({ ...prev, clients: val })), 2000);
      //     animateCounter(500, (val) => setCounters(prev => ({ ...prev, assets: val })), 2000);
      //     animateCounter(15, (val) => setCounters(prev => ({ ...prev, years: val })), 2000);
      //     animateCounter(98, (val) => setCounters(prev => ({ ...prev, satisfaction: val })), 2000);
      //   }
      // }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasAnimated]);

  const toggleLanguage = () => {
    setLanguage(language === 'english' ? 'tamil' : 'english');
  };

  const services = content[language].services.items.map((item, index) => ({
    title: item.title,
    description: item.description,
    features: item.features,
    color: ['from-purple-400 to-pink-400', 'from-blue-400 to-cyan-400', 'from-green-400 to-blue-400'][index]
  }));

  return (
    <div className="min-h-screen bg-gradient-soft">
      <style>
        {`
          .bg-gradient-soft { background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); }
          .bg-gradient-purple { background: linear-gradient(135deg, #e0e7ff 0%, #c3cfe2 100%); }
          .bg-gradient-blue { background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%); }
          .text-gradient { background: linear-gradient(90deg, #8b5cf6, #ec4899); -webkit-background-clip: text; background-clip: text; color: transparent; }
          .text-gradient-gold { background: linear-gradient(90deg, #facc15, #f97316); -webkit-background-clip: text; background-clip: text; color: transparent; }
          @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
          @keyframes slideInBottom { from { opacity: 0; transform: translateY(100%); } to { opacity: 1; transform: translateY(0); } }
          @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
          @keyframes fadeInLeft { from { opacity: 0; transform: translateX(-20px); } to { opacity: 1; transform: translateX(0); } }
          @keyframes fadeInRight { from { opacity: 0; transform: translateX(20px); } to { opacity: 1; transform: translateX(0); } }
          @keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
          @keyframes floating { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-15px); } }
          @keyframes pulseSlow { 0%, 100% { transform: scale(1); opacity: 0.3; } 50% { transform: scale(1.1); opacity: 0.5; } }
          .animate-fade-in-up { animation: fadeInUp 0.8s ease-out forwards; }
          .animate-slide-in-bottom { animation: slideInBottom 0.5s ease-out forwards; }
          .animate-scale-in { animation: scaleIn 0.8s ease-out forwards; }
          .animate-fade-in-left { animation: fadeInLeft 0.8s ease-out forwards; }
          .animate-fade-in-right { animation: fadeInRight 0.8s ease-out forwards; }
          .animate-bounce { animation: bounce 2s infinite; }
          .floating { animation: floating 3s ease-in-out infinite; }
          .floating-delayed { animation: floating 3s ease-in-out infinite 1s; }
          .pulse-slow { animation: pulseSlow 4s ease-in-out infinite; }
          .animation-delay-200 { animation-delay: 0.2s; }
          .animation-delay-400 { animation-delay: 0.4s; }
          .animation-delay-600 { animation-delay: 0.6s; }
          .animation-delay-800 { animation-delay: 0.8s; }
          .animation-delay-1200 { animation-delay: 1.2s; }
          .glow { box-shadow: 0 0 20px rgba(139, 92, 246, 0.5); }
          .font-display { font-family: 'Inter', sans-serif; }
          .image-hover-zoom { overflow: hidden; }
          .image-hover-zoom img { transition: transform 0.5s ease; }
          .image-hover-zoom:hover img { transform: scale(1.1); }
          .text-reveal > * { opacity: 0; animation: fadeInUp 0.8s ease-out forwards; }
          .text-reveal > *:nth-child(2) { animation-delay: 0.4s; }
        `}
      </style>
      <header
  className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
    isScrolled
      ? 'bg-white/95 backdrop-blur-md shadow-xl py-2'
      : 'bg-transparent py-4'
  }`}
>
  <nav className="container mx-auto px-6 flex items-center justify-between">
    {/* Left section: Logo + Social Icons + Language Toggle */}
    <div className="flex items-center space-x-6">
      {/* Logo */}
      <img
        src="/images/image-removebg-preview (2).png"
        alt="Company Logo"
        className="h-12 w-auto"
      />

      {/* Social Icons */}
      <div className="hidden md:flex items-center space-x-4 text-xl">
        <a
          href="https://wa.me/919566666825"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-green-500 transition"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
        <a
          href="mailto:shivanifinancialservices@gmail.com"
          className="hover:text-red-400 transition"
        >
          <FontAwesomeIcon icon={faEnvelope} />
        </a>
        <a
          href="https://www.facebook.com/people/shivani-financial-services/61578736485474/?mibextid=qi2Omg"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-blue-500 transition"
        >
          <FontAwesomeIcon icon={faFacebookF} />
        </a>
        <a
          href="https://www.instagram.com/shivani_financial_service?igsh=MWkzMWJvNWwwOTg0dg=="
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-pink-400 transition"
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>
      </div>

      {/* Language Toggle */}
      <button
        onClick={toggleLanguage}
        className="hidden md:inline-block bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-semibold hover:from-purple-600 hover:to-blue-600 transition duration-300 transform hover:scale-105 shadow-md"
      >
        {language === 'english' ? 'தமிழ்' : 'English'}
      </button>
    </div>

    {/* Desktop Navigation */}
    <div className="hidden md:flex items-center space-x-8">
      {content[language].nav.map((item) => (
        <button
          key={item.id}
          onClick={() => scrollToSection(item.id)}
          className={`text-sm font-semibold transition-all duration-300 hover:text-purple-500 transform hover:scale-105 ${
            activeSection === item.id
              ? 'text-purple-500 font-bold'
              : isScrolled
              ? 'text-gray-700'
              : 'text-white'
          }`}
        >
          {item.label}
        </button>
      ))}
    </div>

    {/* Hamburger Menu (Mobile Only) */}
    <button
      onClick={() => setIsMenuOpen(!isMenuOpen)}
      className={`md:hidden transition-colors duration-300 text-2xl ${
        isScrolled ? 'text-gray-900' : 'text-white'
      }`}
    >
      {isMenuOpen ? '✕' : '☰'}
    </button>
  </nav>

  {/* Mobile Menu */}
  {isMenuOpen && (
    <div className="md:hidden bg-white/95 backdrop-blur-md border-t shadow-lg animate-slide-in-bottom">
      <div className="container mx-auto px-6 py-4 space-y-3">
        {content[language].nav.map((item) => (
          <button
            key={item.id}
            onClick={() => {
              scrollToSection(item.id);
              setIsMenuOpen(false);
            }}
            className={`block w-full text-left py-3 text-gray-700 hover:text-blue-500 transition font-medium ${
              activeSection === item.id ? 'text-blue-500 font-bold' : ''
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  )}
</header>


     <section
  ref={heroRef}
  className="relative flex items-center justify-center w-full h-[100svh] overflow-hidden"
>
  {/* Fallback WebP Background Image */}
  <img
    src="/images/vid.webp"
    alt="Fallback background"
    className="absolute inset-0 w-full h-full object-cover z-0"
  />

  {/* Actual Background Video (load after page is ready) */}
  <video
    className="absolute inset-0 w-full h-full object-cover z-10"
    src="/videos/GettyImages-1387795817.mp4"
    autoPlay
    loop
    muted
    playsInline
    preload="none" // Do not preload to avoid slow load
    onCanPlayThrough={(e) => {
      e.target.previousElementSibling.style.display = 'none'; // Hide fallback image
    }}
  />

  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black opacity-50 z-20"></div>

  {/* Blurred effects */}
  <div className="absolute inset-0 overflow-hidden z-30">
    <div className="absolute top-20 left-20 w-64 h-64 bg-black rounded-full mix-blend-multiply filter blur-xl opacity-30 floating"></div>
    <div className="absolute top-40 right-20 w-96 h-96 bg-black rounded-full mix-blend-multiply filter blur-xl opacity-30 floating-delayed"></div>
  </div>

  {/* Hero Content */}
  <div className="relative z-40 text-center text-white max-w-5xl mx-auto px-6">
    <div className="text-reveal">
      <h1 className="text-4xl md:text-6xl font-display font-bold mb-8 leading-tight">
        <span className="animate-fade-in-up">{content[language].hero.title1}</span>
        <span className="block text-yellow-200 animate-fade-in-up animation-delay-400">
          {content[language].hero.title2}
        </span>
      </h1>
    </div>
    <p className="text-lg md:text-xl mb-10 text-gray-200 max-w-3xl mx-auto leading-relaxed animate-fade-in-up animation-delay-800">
      {content[language].hero.description}
    </p>
    <div className="flex flex-col sm:flex-row gap-6 justify-center animate-fade-in-up animation-delay-1200">
      <button
        onClick={() => scrollToSection('services')}
        className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-full text-lg font-semibold hover:from-purple-600 hover:to-blue-600 transition-all duration-300 transform hover:scale-105 shadow-lg glow"
      >
        {content[language].hero.button1}
      </button>
      <button
        onClick={() => scrollToSection('contact')}
        className="border-2 border-white text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-white hover:text-purple-900 transition-all duration-300 transform hover:scale-105"
      >
        {content[language].hero.button2}
      </button>
    </div>
  </div>
</section>


      <section className="py-16 bg-gradient-purple">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12 animate-fade-in-up">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-800 mb-6">
              {content[language].expertise.title}
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {content[language].expertise.description}
            </p>
          </div>
          <div className="relative max-w-5xl mx-auto">
            <div className="relative h-64 md:h-96 rounded-2xl overflow-hidden shadow-lg">
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-all duration-1000 transform ${index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'}`}
                >
                  <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-2xl font-display font-bold text-white mb-2">{slide.title}</h3>
                    <p className="text-gray-200">{slide.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <button
              onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/20 text-white p-2 rounded-full hover:bg-white/30"
            >
              ←
            </button>
            <button
              onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/20 text-white p-2 rounded-full hover:bg-white/30"
            >
              →
            </button>
            <div className="flex justify-center mt-4 space-x-2">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-2 h-2 rounded-full ${index === currentSlide ? 'bg-purple-500 w-6' : 'bg-gray-400'}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <section ref={servicesRef} className="py-16 bg-gradient-soft">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12 animate-fade-in-up">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-800 mb-6">
              {content[language].services.title}
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {content[language].services.description}
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className={`bg-white/80 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 animate-fade-in-up animation-delay-${200 + index * 100}`}
              >
                <div className={`w-12 h-12 bg-gradient-to-br ${service.color} rounded-lg flex items-center justify-center text-white mb-4`}>
                  {['💰', '🛡️', '📊'][index]}
                </div>
                <h3 className="text-xl font-display font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* <section ref={statsRef} className="py-16 bg-gradient-to-r from-purple-800 to-blue-800 text-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12 animate-fade-in-up">
            <h2 className="text-4xl md:text-5xl font-display font-bold mb-6">
              {content[language].stats.title}
            </h2>
            <p className="text-lg text-purple-200 max-w-2xl mx-auto">
              {content[language].stats.description}
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-8">
            {content[language].stats.items.map((stat, index) => (
              <div key={index} className={`text-center animate-scale-in animation-delay-${200 + index * 200}`}>
                <div className="text-5xl font-display font-bold text-gradient-gold mb-2">
                  {stat.prefix}{counters[Object.keys(counters)[index]].toLocaleString()}{stat.suffix}
                </div>
                <div className="text-lg text-purple-200">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      <section ref={aboutRef} className="py-16 bg-gradient-purple">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="animate-fade-in-left">
              <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-800 mb-6">
                {content[language].about.title1}
                <span className="block text-gradient">{content[language].about.title2}</span>
              </h2>
              <p className="text-lg text-gray-600 mb-6">{content[language].about.description}</p>
              <div className="space-y-4">
                {content[language].about.items.map((item, index) => (
                  <div key={index} className={`flex items-start gap-4 animate-fade-in-up animation-delay-${400 + index * 200}`}>
                    <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center text-white">
                      {['🛡️', '👥', '🏆'][index]}
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900">{item.title}</h3>
                      <p className="text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="animate-fade-in-right">
              <div className="image-hover-zoom rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="/images/pexels-n-voitkevich-6863175.jpg"
                  alt="Financial consultation"
                  className="w-full h-64 md:h-96 object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section ref={contactRef} className="py-16 bg-gradient-blue">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12 animate-fade-in-up">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-800 mb-6">
              {content[language].contact.title}
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {content[language].contact.description}
            </p>
          </div>
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-white/80 rounded-2xl p-6 shadow-lg animate-fade-in-left">
              <h3 className="text-2xl font-display font-bold text-gray-900 mb-4">{content[language].contact.formTitle}</h3>
              <div className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-700 font-medium mb-1">{content[language].contact.form.firstName}</label>
                    <input
                      type="text"
                      className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-purple-500 focus:ring-1 focus:ring-purple-200 outline-none"
                      placeholder={content[language].contact.form.firstName}
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-1">{content[language].contact.form.lastName}</label>
                    <input
                      type="text"
                      className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-purple-500 focus:ring-1 focus:ring-purple-200 outline-none"
                      placeholder={content[language].contact.form.lastName}
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">{content[language].contact.form.email}</label>
                  <input
                    type="email"
                    className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-purple-500 focus:ring-1 focus:ring-purple-200 outline-none"
                    placeholder={content[language].contact.form.email}
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">{content[language].contact.form.phone}</label>
                  <input
                    type="tel"
                    className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-purple-500 focus:ring-1 focus:ring-purple-200 outline-none"
                    placeholder={content[language].contact.form.phone}
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">{content[language].contact.form.serviceInterest}</label>
                  <select className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-purple-500 focus:ring-1 focus:ring-purple-200 outline-none">
                    {content[language].services.items.map((service, index) => (
                      <option key={index}>{service.title}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">{content[language].contact.form.message}</label>
                  <textarea
                    rows={4}
                    className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-purple-500 focus:ring-1 focus:ring-purple-200 outline-none"
                    placeholder={content[language].contact.form.message}
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white py-3 rounded-lg font-semibold hover:from-purple-600 hover:to-pink-600 transition-all duration-300 transform hover:scale-105 shadow-lg glow"
                >
                  {content[language].contact.form.submit}
                </button>
              </div>
            </div>
            <div className="space-y-6 animate-fade-in-right">
              <div className="bg-white/80 rounded-2xl p-6 shadow-lg">
                <h3 className="text-2xl font-display font-bold text-gray-900 mb-4">{content[language].contact.infoTitle}</h3>
                <div className="space-y-4">
                  {content[language].contact.info.map((contact, index) => (
                    <div key={index} className="flex items-center gap-4">
                      <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center text-white">
                        {['📞', '✉️', '📍'][index]}
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900">{contact.title}</div>
                        <div className="text-gray-600">{contact.info}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <footer  ref={contactRef} className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="animate-fade-in-up">
              <div className="flex items-center space-x-3 mb-4">
                <img
    src="/images/image-removebg-preview (2).png"
    alt="Company Logo"
    className="h-12 w-auto"
  />
                {/* <span className="text-xl font-display font-bold">Shivani Financial Services</span> */}
              </div>
              <p className="text-gray-400">{content[language].footer.description}</p>
            </div>
            <div className="animate-fade-in-up animation-delay-200">
              <h4 className="text-lg font-semibold mb-4">{language === 'english' ? 'Services' : 'சேவைகள்'}</h4>
              <ul className="space-y-2 text-gray-400">
                {content[language].footer.services.map((service, index) => (
                  <li key={index}>
                    <a href={`#${service.toLowerCase().replace(' ', '')}`} className="hover:text-white transition-colors duration-300">
                      {service}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            {/* <div className="animate-fade-in-up animation-delay-400">
              <h4 className="text-lg font-semibold mb-4">{language === 'english' ? 'Company' : 'நிறுவனம்'}</h4>
              <ul className="space-y-2 text-gray-400">
                {content[language].footer.company.map((item, index) => (
                  <li key={index}>
                    <a href={`#${item.toLowerCase().replace(' ', '')}`} className="hover:text-white transition-colors duration-300">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div> */}
            <div className="animate-fade-in-up animation-delay-600">
              <h4 className="text-lg font-semibold mb-4">{language === 'english' ? 'Contact' : 'தொடர்பு'}</h4>
              <ul className="space-y-2 text-gray-400">
                {content[language].footer.contact.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              
              <div className="flex space-x-4 mt-4">
  <a href="https://wa.me/919566666825" target="_blank" rel="noopener noreferrer" className="hover:text-green-400 text-xl">
    <FontAwesomeIcon icon={faWhatsapp} />
  </a>
  <a href="mailto:shivanifinancialservices@gmail.com"  className="hover:text-red-400 text-xl">
    <FontAwesomeIcon icon={faEnvelope} />
  </a>
  <a href="https://www.facebook.com/people/shivani-financial-services/61578736485474/?mibextid=qi2Omg&rdid=ypEi01pzBfzBY2c2&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F17BAdCHcRi%2F%3Fmibextid%3Dqi2Omg" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500 text-xl">
    <FontAwesomeIcon icon={faFacebookF} />
  </a>
  <a href="https://www.instagram.com/shivani_financial_service?igsh=MWkzMWJvNWwwOTg0dg==" target="_blank" rel="noopener noreferrer" className="hover:text-pink-400 text-xl">
    <FontAwesomeIcon icon={faInstagram} />
  </a>
</div>

            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-6 text-center text-gray-400 animate-fade-in-up animation-delay-800">
            <p>{content[language].footer.copyright}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;